import { useEffect } from "react";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import InteriorCarousel from "@/components/InteriorCarousel";
import CulinaryTapestry from "@/components/CulinaryTapestry";
import OrderingStrip from "@/components/OrderingStrip";
import CelebrationSection from "@/components/CelebrationSection";
import VisitSection from "@/components/VisitSection";
import Footer from "@/components/Footer";

export const PHONE_DISPLAY = "080040 80054";
export const PHONE_TEL = "tel:08004080054";
export const WHATSAPP_URL = "https://wa.me/918004080054";
export const MAPS_URL = "https://maps.app.goo.gl/1z7XrktzpF9GzKAp7";

function App() {
  useEffect(() => {
    document.documentElement.classList.add("has-js");
    document.title = "Hashtag MultiCuisine Restaurant & Garden | Fine Dining in Varanasi";
    return () => document.documentElement.classList.remove("has-js");
  }, []);

  return (
    <div className="site-shell">
      <Header phoneTel={PHONE_TEL} />
      <main className="site-main">
        <Hero phoneTel={PHONE_TEL} whatsappUrl={WHATSAPP_URL} />
        <Marquee />
        <InteriorCarousel />
        <CulinaryTapestry />
        <OrderingStrip />
        <CelebrationSection whatsappUrl={WHATSAPP_URL} />
        <VisitSection phoneTel={PHONE_TEL} mapsUrl={MAPS_URL} />
      </main>
      <Footer mapsUrl={MAPS_URL} phoneTel={PHONE_TEL} />
    </div>
  );
}

export default App;
